import { useCallback } from 'react';
import { useCurrencyContext } from './currency.provider';
import { CurrencyFormatterArgs } from './types';
import { getCharmPriceForQuantity } from './utils';

export type FormatCurrencyHandler = (args: CurrencyFormatterArgs & { hideZeroDecimals?: boolean }) => string;

export const useCurrencyFormatter = () => {
  const currency = useCurrencyContext();

  const formatCurrency = useCallback<FormatCurrencyHandler>(
    args => {
      const {
        priceFloatingPointDecimalString,
        priceCurrencyCode,
        formatForm,
        formatPrecision,
        shouldRoundPriceUp,
        shouldCalculateCharmPrice,
        canShowFreeLabel,
        hideZeroDecimals = false,
      } = args;

      const floatingPointDecimalString = priceFloatingPointDecimalString ?? '0';

      if (canShowFreeLabel && ['0', '0.00'].includes(floatingPointDecimalString)) {
        // TODO:  i18n
        return 'FREE';
      }

      const priceInMajorUnits = +floatingPointDecimalString;
      const selectedPrice = shouldRoundPriceUp
        ? Math.ceil(priceInMajorUnits)
        : shouldCalculateCharmPrice
        ? getCharmPriceForQuantity(floatingPointDecimalString, 1, priceInMajorUnits)
        : priceInMajorUnits;

      const isWholeNumber = Number.isInteger(selectedPrice);
      const precision = typeof formatPrecision === 'number' ? formatPrecision : hideZeroDecimals && isWholeNumber ? 0 : 2;

      const formattedPrice = currency.formatCurrency(selectedPrice, {
        currency: priceCurrencyCode,
        form: formatForm,
        precision,
      });

      return formattedPrice;
    },
    [currency],
  );

  return {
    formatCurrency,
  };
};
